import { useState } from "react";
import { apiURL } from "../../../consts/URLs";
import { FORGOT_PASSWORD } from "../../endpointList";
import { fetchRequest, getOptions } from "../../utils";

const useRecoveryPassord = () => {
  const [recoveryPasswordResponse, setRecoveryPasswordResonse] =
    useState<any>();
  const [recoveryPasswordResult, setRecoveryPasswordResult] = useState<any>();

  const recoveryPassword = (email: string) => {
    const url = `${apiURL}/${FORGOT_PASSWORD}`;
    const options = getOptions({ method: "POST", body: { email } });
    console.log(options);
    fetchRequest(
      url,
      options,
      setRecoveryPasswordResonse,
      setRecoveryPasswordResult
    );
  };

  return { recoveryPasswordResponse, recoveryPasswordResult, recoveryPassword };
};
export default useRecoveryPassord;
